import axios from 'axios'

const VoicemailService = {
  // Mailboxes
  async listMailboxes(params = {}) {
    return axios.get('voicemails', { params })
  },
  async getMailbox(id) {
    return axios.get(`voicemails/${id}`)
  },
  async createMailbox(payload = {}) {
    return axios.post('voicemails', payload)
  },
  async updateMailbox(id, payload = {}) {
    return axios.put(`voicemails/${id}`, payload)
  },
  async deleteMailbox(id) {
    return axios.delete(`voicemails/${id}`)
  },

  // Messages
  async listMessages(params = {}) {
    return axios.get('voicemessages', { params })
  },
  async getMessage(id) {
    return axios.get(`voicemessages/${id}`)
  },
  async updateMessage(id, payload = {}) {
    return axios.put(`voicemessages/${id}`, payload)
  },
  async deleteMessage(id) {
    return axios.delete(`voicemessages/${id}`)
  },
  async bulk(payload = {}) {
    return axios.put('voicemessages/bulk', payload)
  },

  // Recording blob
  async getRecordingBlob(id) {
    return axios.get(`voicemessages/${id}/recording`, { responseType: 'blob' })
  },

  // User voicemail
  async userMessages() {
    return axios.get('voicemessages/user')
  },
  async userUnreadCount() {
    return axios.get('voicemessages/user/unread-count')
  },

  // Admin greeting (by mailbox ID)
  async greetingStatus(mailboxId) {
    return axios.get(`voicemessages/greeting/${encodeURIComponent(mailboxId)}`)
  },
  async greetingAudio(mailboxId) {
    return axios.get(`voicemessages/greeting/${encodeURIComponent(mailboxId)}/audio`, { responseType: 'blob' })
  },
  async uploadGreetingForMailbox(mailboxId, base64Audio) {
    return axios.post(`voicemessages/greeting/${encodeURIComponent(mailboxId)}`, { recording_base64: base64Audio })
  },
  async deleteGreeting(mailboxId) {
    return axios.delete(`voicemessages/greeting/${encodeURIComponent(mailboxId)}`)
  },

  // User greeting
  async userGreeting() {
    return axios.get('voicemessages/user/greeting')
  },
  async userGreetingAudio() {
    return axios.get('voicemessages/user/greeting/audio', { responseType: 'blob' })
  },
  async uploadGreeting(base64Audio) {
    return axios.post('voicemessages/user/greeting', { recording_base64: base64Audio })
  }
}

export default VoicemailService
